import { Env } from '@protector/utils';

export const {
  AG_OPERATION_MFE_URL,
  AI_INSIGHTS_PROMPTS,
  API_POWER_BI_URL,
  API_REMOTE_SENSING_URL,
  AUTH_SECRET_ID,
  BALANCE_APP_ID,
  BALANCE_URL,
  CHUNK_ANALYTICS_RESULTS,
  CHUNK_PAGE,
  CLIENT_ID,
  CORE_SERVICES_API_URL,
  CROPWISE_ELEMENTS_MFE_URL,
  CROPWISE_URL,
  ENV_CW_COMPONENTS,
  GRIS_API_KEY,
  MAPBOX_DEFAULT_PADDING,
  MAPBOX_KEY,
  MAX_AREAS_ITEMS_IN_AG_OP,
  NEMADIGITAL_APP_ID,
  NEMADIGITAL_URL,
  OAUTH_CROPWISE_URL,
  PDF_SHIFT_API_KEY,
  PLANTING_APP_ID,
  PLANTING_URL,
  PRODUCT_PAGE_SIZE,
  PROTECTOR_API_URL,
  PROTECTOR_APP_ID,
  PROTECTOR_CROPWISE_API_URL,
  RETRY,
  ROLLOUT_KEY,
  STATIC_ASSETS_URL,
  TEN_MINUTES,
  TOP_BAR_ELEMENT_ID,
  VITE_AMPLITUDE_ID,
  VITE_ENV
} = Env;
